import Honeybadger from "@honeybadger-io/js"

import { AppError } from "./AppError"

export interface RequestErrorArgs {
  message?: string
  response: Response | null
  path: RequestInfo | URL
  init?: RequestInit
}

export class RequestError extends AppError {
  response: Response | null

  init?: RequestInit

  path: RequestInfo | URL

  constructor(args: RequestErrorArgs) {
    super(
      args.message ||
        (args.response?.status
          ? `Request failed with status ${args.response.status}`
          : "Request failed")
    )
    this.response = args.response
    this.init = args.init
    this.path = args.path
  }

  async notify() {
    let responseBody: string | null = null
    try {
      responseBody = this.response ? await this.response.clone().json() : null
    } catch {
      // ignore JSON parsing errors
    }

    Honeybadger.notify(this, {
      name: this.response?.status
        ? `${this.name}: ${this.response.status}`
        : this.name,
      message: this.message,
      stack: this.stack,
      params: {
        path: this.path,
        requestBody: this.init?.body?.toString(),
        responseBody
      }
    })
  }
}
